import React from 'react';
import HeroCarousel from './HeroCarousel';

const FabricShowcase = () => {
  const fabricImages = [
    {
      src: 'images/arihant sales.png',
      alt: 'ARIHANT SALES Store - Largest Fabric Shop in Jabalpur MP'
    },
    {
      src: 'images/stock.png',
      alt: 'Wholesale Fabric Stock Jabalpur - Variety of colors and materials'
    },
    {
      src: 'images/NS LYCRA.jpg',
      alt: 'Lycra Fabric Wholesaler Jabalpur - High quality NS Lycra'
    },
    {
      src: 'images/download.jpg',
      alt: 'Premium Fabric Inventory Jabalpur - Sportswear and Hosiery'
    },
    {
      src: 'images/inventory.png',
      alt: 'Bulk Fabric Supplies Jabalpur - Best rates for manufacturers'
    }
  ];

  return (
    <section className="pt-4 pb-12 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
            Jabalpur's Best <span className="text-primary">Fabric</span> Wholesale Collection
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our vast inventory of 2-way, 4-way, Zurich, and Sportswear fabrics in Jabalpur, MP
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <HeroCarousel images={fabricImages} />
        </div>
      </div>
    </section>
  );
};

export default FabricShowcase;
